import "./MainContent.css";
import React, { useState, useRef, useEffect } from "react";
import validator from "validator";
import Cookies from "js-cookie";
import axios from "../axios.jsx";
import { useNavigate } from "react-router-dom";

function MainContent() {
  const navigate = useNavigate();
  let [authMode, setAuthMode] = useState("signin");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileValid, setMobileValid] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");
  const [loginError, setLoginError] = useState("");
  const [passwordValid, setPasswordValid] = useState("");
  const [password, setPassword] = useState("");
  const [security, setSecurity] = useState("");
  const [btnDisabeled, setBtnDisabled] = useState(true);
  axios.defaults.xsrfCookieName = "csrftoken";
  axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

  const changeAuthMode = (mode) => {
    setAuthMode(mode);
  };
  const handleSignInSubmit = async (e) => {
    e.preventDefault();
    var reqData = {
      mobile: mobile,
      password: password,
    };
    if (mobile.length != 10) {
      setMobileValid("Invalid Mobile Number it contains only" + mobile.length + " characters");
      return;
    }
    try {
      const resData = await axios.post("/api/scholar-login", reqData);
      if (resData.status === 200) {
        Cookies.set("username",resData.data.username);
        Cookies.set("userInfo",resData.data.userInfo);
        navigate("/status", { "mobile": mobile });
      }
    } catch (e) {
      setLoginError("Invalid Mobile Number or Password");
    }
  };

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    var reqData = {
      mobile: mobile,
      password: password,
      security: security,
    };
    if (mobile.length != 10) {
      setLoginError("Invalid Mobile Number it contains only" + mobile.length + " characters");
      return;
    }
    if ( mobileValid === "") {
      try {
        const resData = await axios.post("/api/forgot-password", reqData);
        if (resData.status === 200) {
          setAuthMode("signin");
          setLoginError("");
        }
      } catch (e) {
        setLoginError("Invalid Mobile Number or Security Answer");
      }
    }
    else {
      setLoginError("Invalid Password");
    }
  };

  const handleSignUpSubmit = async (e) => {
    e.preventDefault();
    var reqData = {
      name: name,
      mobile: mobile,
      security: security,
      password: password,
    };
    if (mobile.length != 10) {
      setLoginError("Invalid Mobile Number it contains only " + mobile.length + " characters");
      return;
    }
    if ( mobileValid === "") {
      try {
        const resData = await axios.post("/api/create-scholar", reqData);
        if (resData.status === 201) {
          try {
            const resData2 = await axios.post("/api/create-application", reqData);
            if (resData2.status === 201) {
              setAuthMode("signin");
              setLoginError("");
            }
          } catch (e) {
            setLoginError("Something went wrong please try again");
          }
        }
        else {
          setLoginError(resData.data['Message']);
        }
      } catch (e) {
        setLoginError("Something went wrong please try again");
      }
    }
  };
  const checkPassword = (e) => {
    
      setPasswordSuccess("Is valid Password");
  };
  const validatePasswords = (e) => {
    if (password === e.target.value) {
      setPasswordError("");
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
      setPasswordError("Passwords does not match");
    }
  };
  const validateMobile = (e) => {
    if (validator.isMobilePhone(e, "en-IN") && e.length === 10) {
      setMobileValid("");
    } else {
      setMobileValid("Invalid Mobile Number");
    }
  };
  if (authMode === "signin") {
    return (
      <div className="Auth-form-container">
        <form onSubmit={handleSignInSubmit} className="Auth-form">
          <div className="Auth-form-content">
            <h3 className="Auth-form-title">Scholar Sign In</h3>
            <div className="text-center">
              Not registered yet?{" "}
              <span className="link-primary" onClick={(mode) => changeAuthMode("signup")}>
                Sign Up
              </span>
            </div>
            <div className="form-group mt-3">
              <label>Mobile</label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="form-control mt-1"
                placeholder="Enter mobile number"
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control mt-1"
                placeholder="Enter password"
                required
              />
            </div>
            <div className="d-grid gap-2 mt-3">
              <button
                type="submit"
                className="btn btn-secondary"
              >Submit</button>

            </div>
            <p className="text-center mt-2">
              Forgot{" "}
              <span className="link-primary" onClick={(mode) => changeAuthMode("forgot")}>
                Password?
              </span>
            </p>
            <span className="text-danger justify-content-center">{loginError}</span>
          </div>
        </form>
      </div>
    );
  }
  else if (authMode === "forgot") {
    return (
      <div className="Auth-form-container">
        <form onSubmit={handleForgotSubmit} className="Auth-form">
          <div className="Auth-form-content">
            <h3 className="Auth-form-title">Scholar Forgot Password</h3>
            <div className="text-center">
              Not registered yet?{" "}
              <span className="link-primary" onClick={(mode) => changeAuthMode("signup")}>
                Sign Up
              </span>
            </div>
            <div className="form-group mt-3">
              <label>Mobile</label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => {
                  setMobile(e.target.value)
                  validateMobile(e.target.value);
                }
                }
                className="form-control mt-1"
                placeholder="Enter mobile number"
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>
                Security Question:
                <br />
                Who is your Childhood Friend?
              </label>
              <input
                type="text"
                value={security}
                onChange={(e) => setSecurity(e.target.value)}
                className="form-control mt-1"
                placeholder="Enter Answer"
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>New Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  checkPassword(e.target.value);
                }}
                className="form-control mt-1"
                placeholder="Password"
                required
              />
              <small>
                <span className="text-danger">{passwordValid}</span>
                <span className="text-success">{passwordSuccess}</span>
              </small>
            </div>
            <div className="form-group mt-3">
              <label>Confirm Password</label>
              <input
                type="password"
                onChange={validatePasswords}
                className="form-control mt-1"
                placeholder="Enter password again"
                required
              />
              <span className="text-danger">{passwordError}</span>
            </div>
            <div className="d-grid gap-2 mt-3">
              <button
                type="submit"
                className="btn btn-secondary"
              >
                Submit
              </button>
            </div>
            <span className="text-danger justify-content-center">{loginError}</span><br></br>
            <div className="text-center">
              Already registered?{" "}
              <span className="link-primary" onClick={(mode) => changeAuthMode("signin")}>
                Sign In
              </span>
            </div><br></br>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div className="Auth-form-container">
      <form onSubmit={handleSignUpSubmit} className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Scholar Sign Up</h3>
          <div className="text-center">
            Already registered?{" "}
            <span className="link-primary" onClick={(mode) => changeAuthMode("signin")}>
              Sign In
            </span>
          </div>
          <div className="form-group mt-3">
            <label>Full Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="form-control mt-1"
              placeholder="Enter Full Name"
              required
            />
          </div>
          <div className="form-group mt-3">
            <label>Mobile Number</label>
            <input
              type="tel"
              value={mobile}
              onChange={(e) => {
                setMobile(e.target.value);
                validateMobile(e.target.value);
              }}
              className="form-control mt-1"
              placeholder="Mobile Number"
              required
            />
            <small>
              <span className="text-danger">{mobileValid}</span>
            </small>
          </div>
          <div className="form-group mt-3">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                checkPassword(e.target.value);
              }}
              className="form-control mt-1"
              placeholder="Password"
              required
            />
            <small>
              <span className="text-danger">{passwordValid}</span>
              <span className="text-success">{passwordSuccess}</span>
            </small>
          </div>
          <div className="form-group mt-3">
            <label>Confirm Password</label>
            <input
              type="password"
              onChange={validatePasswords}
              className="form-control mt-1"
              placeholder="Enter password again"
              required
            />
            <span className="text-danger">{passwordError}</span>
          </div>
          <div className="form-group mt-3">
            <label>
              Security Question:
              <br />
              Who is your Childhood Friend?
            </label>
            <input
              type="text"
              value={security}
              onChange={(e) => setSecurity(e.target.value)}
              className="form-control mt-1"
              placeholder="Enter Answer"
              required
            />
          </div>
          <div className="d-grid gap-2 mt-3">
            <button
              type="submit"
              className="btn btn-secondary"
              disabled={btnDisabeled}
            >
              Submit
            </button>
          </div>
          <span className="text-danger justify-content-center">{loginError}</span><br></br>
          <p className="text-center mt-2">
            Forgot{" "}
            <span className="link-primary" onClick={(mode) => changeAuthMode("forgot")}>
              Password?
            </span>
          </p>
        </div>
      </form>
    </div>
  );
}
export default MainContent;
